import React from 'react';
import Icon from '../../../components/AppIcon';

const IndustryExpertise = () => {
  const expertiseAreas = [
    {
      id: 1,
      icon: "Shield",
      title: "Regulatory Compliance",
      description: "Deep understanding of HIPAA, SOC 2, GDPR, PCI-DSS, and industry-specific regulations ensuring your solution meets all compliance requirements from day one."
    },
    {
      id: 2,
      icon: "Lock",
      title: "Security Architecture",
      description: "Enterprise-grade security implementations with encryption, access controls, audit trails, and threat monitoring tailored to industry risk profiles."
    },
    {
      id: 3,
      icon: "Zap",
      title: "Scalability Planning",
      description: "Infrastructure designed for growth with load balancing, microservices architecture, and cloud-native solutions that scale with your business demands."
    },
    {
      id: 4,
      icon: "GitBranch",
      title: "Integration Expertise",
      description: "Seamless connectivity with industry-standard systems, legacy platforms, and third-party services through robust API development and middleware solutions."
    },
    {
      id: 5,
      icon: "Database",
      title: "Data Management",
      description: "Advanced data architecture with warehousing, analytics pipelines, and real-time processing capabilities for business intelligence and reporting."
    },
    {
      id: 6,
      icon: "Smartphone",
      title: "Mobile Solutions",
      description: "Native and cross-platform mobile applications optimized for field operations, customer engagement, and workforce productivity in your industry."
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center space-x-2 bg-accent/10 text-accent px-4 py-2 rounded-full text-sm font-medium font-body mb-4">
            <Icon name="Star" size={16} />
            <span>Technical Excellence</span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-headline text-foreground mb-4">
            Cross-Industry Technical Capabilities
          </h2>
          <p className="text-base md:text-lg text-muted-foreground font-body max-w-3xl mx-auto">
            Specialized expertise that addresses the unique technical and business challenges of complex industries
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {expertiseAreas?.map((area) => (
            <div
              key={area?.id}
              className="bg-card rounded-xl p-6 shadow-md hover:shadow-lg transition-all duration-300 border border-border group hover:border-primary/50"
            >
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors duration-300">
                <Icon name={area?.icon} size={24} className="text-primary" />
              </div>
              <h3 className="text-lg md:text-xl font-bold font-headline text-foreground mb-3">
                {area?.title}
              </h3>
              <p className="text-sm md:text-base text-muted-foreground font-body leading-relaxed">
                {area?.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustryExpertise;